import React from 'react'
import Rectangle from 'blocks.simple/rectangle/rectangle'
import Button from 'blocks.simple/button/button'
import Icon from 'blocks.simple/icon/icon'
import ItemBroadcasts from '../../__item/_broadcasts/catalog__item_broadcasts'
import { api } from 'core/api/ConnectionManager'
import helpers, { addListener } from 'core/helpers'
import translate from 'core/translate'
import { cn } from 'ethcss'
import styles from './catalog__template_broadcasts.jcss'
import { routes } from 'features/routes'
import broadcastsHelpers from 'core/helpers/_broadcasts'
import helpersDisplays from 'core/helpers/_digitalSignages'
import { getThemeStyleValue } from 'theme/colors'
import { defaultThemeStyles } from 'blocks.simple/icon/icon.theme'
import { getURLSearchParamsByLocation, getURLSearchParamsString } from 'features/routes/utils'
import { getParamsForMultipleMoveBroadcasts } from 'core/utils/broadcastUtil'
import { changeLocation } from 'features/routes'

const onUpdateSchedule = (cb) => ({ broadcastId }) => {
    api.send('getBroadcast', { id: broadcastId }).then((dataItem) => cb(dataItem))
}
export default {
    folderName: 'folderId',
    getMethod: 'getBroadcastsAndFolders',
    emptySearchText: () => translate('notFound'),
    emptyFolderText: () => translate('noBroadcasts'),
    emptyIcon: 'not_allow',
    moveItem: (broadcastId, parentId) => api.send('moveToBroadcastFolder', { broadcastId, parentId }),
    moveFolder: (broadcastFolderId, parentId) => api.send('moveToBroadcastFolder', { broadcastFolderId, parentId }),
    multipleMove: (broadcastId, broadcastFolderId, parentId) => {
        const params = getParamsForMultipleMoveBroadcasts(broadcastId, broadcastFolderId, parentId)
        return api.send('moveToBroadcastFolder', params)
    },
    getDragData: (p_) => {
        return JSON.stringify({ id: p_.item.id, instanceType: p_.item.instanceType })
    },
    addItemButton: (self) => {
        let path = null
        const keys = ['addAdvancedBroadcast', 'addVideowall', 'addContentToDevice']

        keys.forEach((name) => {
            if (
                !path &&
                (helpers.isAvailableMenu({ key: 'broadcasts', name }) || helpers.isAvailableMenu({ key: name }))
            ) {
                path = routes[name].path
            }
        })

        if (!path) {
            return null
        }

        return (
            <Button
                rounded="full_md"
                onClick={() => {
                    const query = getURLSearchParamsByLocation(self.props.location)
                    const queryString = getURLSearchParamsString({
                        broadcastFolderId: query.folderId,
                    })

                    changeLocation({
                        pathname: `/${path}`,
                        search: queryString,
                    })
                }}
            >
                {translate('add')}
            </Button>
        )
    },
    settingsPrefixes: 'broadcast',
    tile: ItemBroadcasts,
    viewOptions: () => [
        {
            id: 'tile',
            name: translate('tile'),
            icon: 'tile',
            iconColor: getThemeStyleValue('ui', 'icon', 'disable') || defaultThemeStyles.disable,
            iconActiveColor: getThemeStyleValue('ui', 'icon', 'active') || defaultThemeStyles.active,
        },
        {
            id: 'list',
            name: translate('list'),
            icon: 'list',
            iconColor: getThemeStyleValue('ui', 'icon', 'disable') || defaultThemeStyles.disable,
            iconActiveColor: getThemeStyleValue('ui', 'icon', 'active') || defaultThemeStyles.active,
        },
    ],
    sortOptions: () => [
        { id: '-createdAt', name: translate('sortCreatedAt') },
        { id: 'title', name: translate('byNameAsc') },
    ],
    getItemModel: (dataItem, getSelected) => {
        const item = { ...dataItem }
        if (item.cover === 'ignore') {
            delete item.cover
        } else {
            item.cover = helpers.getBroadcastCover(item.coverSource)
        }

        if (!item.__view) {
            item.__view = {
                selected: getSelected(item),
            }
        }

        return item
    },
    getBackendModel: (item) => {
        if (!broadcastsHelpers.isDirectory(item)) {
            return api.send('getBroadcast', { id: item.id }, { hideLoader: true })
        } else {
            return api.send('getBroadcastFolder', { id: item.id }, { hideLoader: true })
        }
    },
    isEqual: (item, prevItem) => broadcastsHelpers.isEqual(item, prevItem),
    onCreateListeners: [
        (cb, clearList) => api.addObserver('broadcastCreated', cb, clearList),
        (callback, clearList) =>
            api.addObserver(
                'broadcastFolderCreated',
                (dataItem) => callback({ ...dataItem, instanceType: 'broadcastFolder' }),
                clearList
            ),
    ],
    onUpdateListeners: [
        (cb, clearList) => api.addObserver('broadcastUpdated', cb, clearList),
        addListener.updateBroadcastProgress,
        (callback, clearList) =>
            api.addObserver(
                'broadcastFolderUpdated',
                (dataItem) => callback({ ...dataItem, instanceType: 'broadcastFolder' }),
                clearList
            ),
        (cb, clearList) => api.addObserver('scheduleCreated', onUpdateSchedule(cb), clearList),
        (cb, clearList) => api.addObserver('scheduleUpdated', onUpdateSchedule(cb), clearList),
        (cb, clearList) => api.addObserver('scheduleDeleted', onUpdateSchedule(cb), clearList),
    ],
    onDeleteListeners: [
        (callback, clearList) => api.addObserver('broadcastDeleted', ({ id }) => callback({ id }), clearList),
        (callback, clearList) =>
            api.addObserver(
                'broadcastFolderDeleted',
                ({ id }) => callback({ id, instanceType: 'broadcastFolder' }),
                clearList
            ),
    ],
    isFolder: (item) => broadcastsHelpers.isDirectory(item),
    fields: () => [
        { id: 'cover', name: translate('Campaign'), hide: true },
        { id: 'title', name: translate('name') },
        { id: 'orientation', name: translate('orientation') },
        { id: 'broadcastType', name: translate('typeBroadcast') },
        { id: 'createdAt', name: translate('createdAt') },
    ],
    init(callback) {
        this.setState({ isInit: true, fields: this.template.fields() }, callback)
    },
    getBreadcrumbs(folderId) {
        const initBreadcrumb = { name: 'broadcasts', id: undefined }

        if (folderId) {
            api.send('getBroadcastFolderBreadcrumbs', { folderId }).then((breadcrumbsList) => {
                const breadcrumbs = breadcrumbsList
                    .reverse()
                    .map((breadcrumb) => ({ ...breadcrumb, name: breadcrumb.title }))
                breadcrumbs.unshift(initBreadcrumb)
                this.setState({ breadcrumbs })
            })
        } else {
            this.setState({ breadcrumbs: [initBreadcrumb] })
        }
    },
    moveOnUpdate(item) {
        let currentFolderId = this.query.folderId

        if (currentFolderId) {
            currentFolderId = parseInt(currentFolderId, 10)
        } else {
            return false
        }

        return !this.query.fileType && item.folderId !== currentFolderId
    },
    list: {
        title: (item, active, p_, nested) => {
            const { cover } = item
            const isDirectory = broadcastsHelpers.isDirectory(item)

            return (
                <div
                    className={styles.name}
                    style={{
                        marginLeft: 40 * nested,
                    }}
                >
                    {isDirectory && <Icon className={styles.icon} type="files" />}
                    {!isDirectory && (
                        <div className={cn(styles.image, styles.icon)}>
                            <Rectangle width="2" height="1" src={cover.src} contain={cover.isIcon} />
                        </div>
                    )}
                    <div>{item.title}</div>
                </div>
            )
        },
        orientation: ({ orientation }) => {
            const broadcastOrientation = helpersDisplays.getOrientation(orientation)

            if (!broadcastOrientation) {
                return null
            }

            return broadcastOrientation.name
        },
        broadcastType: ({ broadcastType }) => {
            if (broadcastType === 'simple') {
                return translate('simpleBroadcast')
            } else if (broadcastType === 'advanced') {
                return translate('advancedBroadcast')
            }
        },
        createdAt: ({ createdAt }) => helpers.getFormattedLocalDate(createdAt, 'DD/MM/YYYY'),
    },
}
